import type maplibregl from "maplibre-gl";
import type { StyleValue } from "../types";

type Props = {
	attribute: string;
	cases: Array<[label: string, value: StyleValue]>;
	fallback: StyleValue;
};

function buildMatchExpression({ attribute, cases, fallback }: Props): maplibregl.ExpressionSpecification {
	if (cases.length === 0) {
		return fallback as unknown as maplibregl.ExpressionSpecification;
	}

	return ["match", ["get", attribute], ...cases.flat(), fallback] as unknown as maplibregl.ExpressionSpecification;
}

export { buildMatchExpression };
